<template>
  <v-dialog v-model="show_modal" persistent eager max-width="800">
    <v-card>
      <v-form
        ref="form"
        v-model="form_validate_status"
        v-on:submit.prevent="add"
      >
        <v-card-title class="headline">
          ตั้งค่ารายละเอียดค่าธรรมเนียมการศึกษา (
          {{
            form_mode === FORM_MODES.ADD
              ? $t("config_academic.addnew")
              : $t("config_academic.edit")
          }}
          ) <br />
          {{ level == 2 ? "ระดับปริญญาโท" : "ระดับปริญญาเอก" }}
        </v-card-title>

        <hr />

        <v-card-text class="mt-5">
          <v-row>
            <v-col class="pt-0 pb-0" cols="12" md="12">
              <v-chip color="black" dark class="mr-2">
                {{ name_faculty }}
              </v-chip>
              <v-chip color="gray" class="mr-2">
                {{ name_curriculum }}
              </v-chip>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pb-0" cols="12" md="12">
              <v-chip color="orange" dark class="mr-2">
                ปีรับเข้า {{ semester }}/{{ year }}
              </v-chip>
              <v-chip color="blue" dark class="mr-2">
                ประเภทการรับเข้า : {{ name_admis_type }}
              </v-chip>
              <v-chip color="green" dark class="mr-2">
                สำหรับ : 
                <span
                class="ml-1"
                  :style="{
                    color: name_thai_or_foreign == 'นักศึกษาต่างชาติ' ? 'blue' : '',
                  }"
                >
                  {{ name_thai_or_foreign }}</span
                >
              </v-chip>
              <v-chip color="red" dark class="mr-2">
                แผนการศึกษา : {{ name_study_plan }}
              </v-chip>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-text class="mt-5">
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                label="ค่าเทอมเหมาจ่าย"
                v-model="package_fee"
                outlined
                dense
                type="number"
                v-bind:rules="tuitionFeeRules"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                label="ค่ารักษาสภาพนักศึกษา"
                v-model="maintain_fee"
                outlined
                dense
                type="number"
                v-bind:rules="tuitionFeeRules"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field
                label="ค่าลาพักการศึกษา"
                v-model="leave_fee"
                outlined
                dense
                type="number"
                v-bind:rules="tuitionFeeRules"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                label="ค่าเทอม Summer"
                v-model="summer_fee"
                outlined
                dense
                type="number"
                v-bind:rules="required"
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="pb-5 pr-4">
          <v-spacer></v-spacer>
          <v-btn
            class="ml-5"
            color="success"
            @click="form_validate()"
            :disabled="!form_validate_status"
          >
            บันทึก
          </v-btn>
          <v-btn color="error" @click="show_modal = false">ยกเลิก</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import ConfigProvider from "@/services/config.provider";

const configService = new ConfigProvider();
const FORM_MODES = { ADD: 0, EDIT: 1 };

export default {
  name: "ConfigGraduateCurriculumFeeAddEditDialog",

  props: {
    toggle_loading: Function,
    fetch_data: Function,
  },

  data: () => ({
    FORM_MODES,

    form_mode: null,
    form_validate_status: null,
    show_modal: false,

    level: null,
    faculty_id: null,
    curriculum_id: null,
    admis_type_id: null,
    year: null,
    semester: null,
    thai_or_foreign: null,
    prog_id: null,
    name_faculty: null,
    name_curriculum: null,
    name_admis_type: null,
    name_thai_or_foreign: null,
    name_study_plan: null,

    package_fee: null,
    maintain_fee: null,
    leave_fee: null,
    summer_fee: null,

    required: [(v) => !!v || "Required"],
    tuitionFeeRules: [
      (v) => !!v || "Tuition fee is required",
      (v) => (v && v > 0) || "Tuition fee must be a number greater than 0",
    ],
  }),

  components: {},

  computed: {},

  methods: {
    open_add_modal: function (
      selected_level,
      selected_faculty_id,
      selected_curriculum_id,
      selected_year,
      selected_semester,
      selected_admis_type_id,
      selected_thai_or_foreign,
      selected_prog_id,
      name_faculty,
      name_curriculum,
      name_admis_type,
      name_thai_or_foreign,
      name_study_plan
    ) {
      this.show_modal = true;
      this.form_mode = FORM_MODES.ADD;
      this.level = selected_level;
      this.faculty_id = selected_faculty_id;
      this.curriculum_id = selected_curriculum_id;
      this.year = selected_year;
      this.semester = selected_semester;
      this.admis_type_id = selected_admis_type_id;
      this.thai_or_foreign = selected_thai_or_foreign;
      this.prog_id = selected_prog_id;
      this.name_faculty = name_faculty;
      this.name_curriculum = name_curriculum;
      this.name_admis_type = name_admis_type;
      this.name_thai_or_foreign = name_thai_or_foreign;
      this.name_study_plan = name_study_plan;
      this.package_fee = null;
      this.maintain_fee = null;
      this.leave_fee = null;
      this.summer_fee = null;
    },

    open_edit_modal: function (
      selected_level,
      selected_faculty_id,
      selected_curriculum_id,
      selected_year,
      selected_semester,
      selected_admis_type_id,
      selected_thai_or_foreign,
      selected_prog_id,
      name_faculty,
      name_curriculum,
      name_admis_type,
      name_thai_or_foreign,
      name_study_plan,
      item
    ) {
      this.show_modal = true;
      this.form_mode = FORM_MODES.EDIT;
      this.level = selected_level;
      this.faculty_id = selected_faculty_id;
      this.curriculum_id = selected_curriculum_id;
      this.year = selected_year;
      this.semester = selected_semester;
      this.admis_type_id = item.admis_type;
      this.thai_or_foreign = item.inter_student;
      this.prog_id = item.prog_id;
      this.name_faculty = name_faculty;
      this.name_curriculum = name_curriculum;
      this.name_admis_type = item.admis_type_name;
      this.name_thai_or_foreign =
        item.inter_student == 1 ? "นักศึกษาต่างชาติ" : "นักศึกษาไทย";
      this.name_study_plan = item.study_plan_name;
      this.package_fee = item.package_fee;
      this.maintain_fee = item.maintain_fee;
      this.leave_fee = item.leave_fee;
      this.summer_fee = item.summer_fee;
    },

    form_validate: function () {
      this.$refs.form.validate();
      if (
        this.form_mode === FORM_MODES.ADD ||
        this.form_mode === FORM_MODES.EDIT
      ) {
        this.addAndEdit();
      }
    },

    addAndEdit: async function () {
      this.show_modal = false;
      this.toggle_loading(true);

      let response = await configService
        .setGraduateCurriculumFee({
          faculty_id: this.faculty_id,
          curr_id: this.curriculum_id,
          admis_type: this.admis_type_id,
          admis_year: this.year,
          admis_term: this.semester,
          inter_student: this.thai_or_foreign,
          prog_id: this.prog_id,
          package_fee: this.package_fee,
          maintain_fee: this.maintain_fee,
          leave_fee: this.leave_fee,
          summer_fee: this.summer_fee,
        })
        .catch((error) => {
          this.$toasted.error(JSON.stringify(error.response.data.message), {
            duration: 0,
          });
          this.toggle_loading(false);
        });
      this.fetch_data();
      if (response && response.status)
        this.$toasted.success(this.$t("toasted.create_successfully"));
      else this.$toasted.error(this.$t("toasted.cannot_create"));
    },
  },

  mounted: function () {},
};
</script>
<style scoped>
.warning-text {
  color: white;
  background-color: rgb(226, 162, 42);
  border-radius: 5px;
  padding: 5px;
}
</style>
